import { useContext, useEffect, useState } from "react"
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { RxExternalLink } from "react-icons/rx";
import shopContext from "src/context/shopContext";
import { TbReload } from "react-icons/tb";

import moment from 'jalali-moment';
import { get } from "src/services/HttpClient";
import InputBox from "../SellerManagement/components/InputBox";
import { put } from "src/services/HttpClient/HttpClient";

export default function Products() {

    const { products, setProducts } = useContext(shopContext)
    // const [products, setProducts] = useState()


    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        getData(setProducts, "/products?limit=100000", {}, signal)

        return () => {
            controller.abort();
        };
    }, [])

    const columns = [
        {
            id: "featuredImage",
            cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${info.row.original.id}/${info.getValue()}`} />),
            header: "تصویر",
            inExport: false
        },
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "name",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام محصول",
        },
        {
            id: "sku",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "sku",
        },
        {
            id: "barcode",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "بارکد",
        },
        {
            id: "stockQuantity",
            cell: (info) => <InputBox
                isMinify
                defaultValue={info.getValue()}
                handleClick={async (value) => {
                    await put("products/" + info.row.original.id, {
                        "stockQuantity": value
                    })
                }}
                type="number"
            />,
            header: "موجودی",
        },
        {
            id: "price",
            cell: (info) => <div className="flex gap-1 items-center justify-center">
                <InputBox
                    defaultValue={numberWithCommas(info.getValue())}
                    handleClick={async (value) => {
                        await put("products/" + info.row.original.id, {
                            "price": value
                        })
                    }}
                />تومان</div>,
            header: "قیمت مصرف کننده",
        },
        {
            id: "salePrice",
            cell: (info) => <div className="flex gap-1 items-center justify-center">
                <InputBox
                    defaultValue={numberWithCommas(info.getValue())}
                    handleClick={async (value) => {
                        await put("products/" + info.row.original.id, {
                            "salePrice": value
                        })
                    }}
                />تومان</div>,
            header: "قیمت فروش ویژه",
        },
        {
            id: "date_on_sale_from",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "شروع فروش ویژه",
        },
        {
            id: "date_on_sale_to",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "پایان فروش ویژه",
        },
        {
            id: "priority",
            cell: (info) => <div className="flex gap-1 items-center justify-center">
                <InputBox
                    isMinify
                    defaultValue={info.getValue()}
                    handleClick={async (value) => {
                        await put("products/" + info.row.original.id, {
                            "priority": value
                        })
                    }}
                /></div>,
            header: "ترتیب نمایش",
            inExport: false
        },
        {
            id: "seller",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "فروشنده",
        },
        {
            id: "categories",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "دسته بندی",
        },
        {
            id: "tags",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "برچسب",
        },
        {
            id: "brand",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "برند",
        },
        {
            id: "maxOrder",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "حداکثر تعداد سفارش",
            inTable: false,
            inExport: true
        },
        {
            id: "status",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "وضعیت انتشار",
            inExport: true,
            inTable: false
        },

        {
            id: "slug",
            cell: (info) => (
                <div className="flex gap-2">
                    <a
                        title="لینک محصول"
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                        target="_blank"
                        href={process.env.REACT_APP_SITE_URL + '/product/' + info.getValue()}
                    >
                        <RxExternalLink className="text-blue-500" />
                    </a>
                </div>
            ),
            header: "آدرس",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        },
        {
            id: "priority",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "ترتیب نمایش",
            inExport: true,
            inTable: false
        },
    ];

    return (
        <>
            <PageHeader
                title="لیست محصولات"
                btnTitle="بروزرسانی"
                handleClick={async () => {
                    setProducts();
                    await get("/products/s/purgeCache")
                    setTimeout(() => {
                        getData(setProducts, "/products");
                    }, 500);
                }}
                isBtnLoading={!products}
                btnIcon={<TbReload className="ml-1" size="22" />}
            />

            <Table
                columns={columns}
                data={products}
                // requestPath="/productsPages"
                // setRequestData={setProducts}
                // isLiveGlobalSearch={false}
                // isBackendGlobalSearch={true}
                CSVExportPermission="exportProducts"
                tableName="products"
            />
        </>
    )
}